<template>
  <v-menu transition="slide-y-transition" bottom left max-width="300">
    <template v-slot:activator="{ on }">
      <div class="d-flex fill-height align-center flex-nowrap">
        <div class="text-right caption" v-if="retail == 1">
          <div class="d-flex align-center grey--text" style="min-width: 91px">
            {{ $t("balanceAgent") }}
          </div>
          <div class>
            {{
              cash > 9999 ? $t("unlimited") : $t("labelCurrency") + " " + cash
            }}
          </div>
        </div>
        <div>
          <v-btn
            fab
            depressed
            small
            v-on="on"
            color="accent black--text"
            class="ml-4"
            >{{ initialsName }}</v-btn
          >
        </div>
      </div>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-avatar color="accent black--text">{{
            initialsName
          }}</v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ userInfo.nome_usuario }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item @click="ToRoute()">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t("dashboard") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          :disabled="$route.matched[0].name === 'main'"
          :to="{
            name: 'bigTable',
          }"
        >
          <v-list-item-action>
            <v-icon>mdi-home-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title> {{ $t("goToWebsite") }} </v-list-item-title>
        </v-list-item>

        <div class="pa-2" v-if="$isCreditOnline()">
          <v-btn
            v-if="affiliateLevel == 0"
            block
            color="primary"
            @click="$copy(getInviteLink())"
          >
            <v-icon left>mdi-content-copy</v-icon>
            {{ $t("invitePlayer") }}
          </v-btn>

          <CreateNewCampaignDialog
            v-if="affiliateLevel != 0"
            :disabledBtn="$route.name == 'AgentListCampaigns'"
          />
        </div>
      </v-list>

      <v-divider></v-divider>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn depressed @click="$logout()">{{ $t("exit") }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import CreateNewCampaignDialog from '../../views/dashboard/agent/campaigns/CreateNewCampaignDialog.vue';
export default {
  name: "User",
  components: {
    CreateNewCampaignDialog
  },
  data: () => ({
    userInfo: "",
    firstName: "",
    initialsName: "",
  }),

  computed: {
    retail() {
      return this.$store.state.operators.retail;
    },
    cash() {
      return this.$store.state.cash;
    },
    innerSport() {
      return this.$store.state.innerSport;
    },
    idVinculo() {
      return this.$store.state.logged.data.id_vinculo;
    },
    getQuery() {
      return this.$route.fullPath;
    },
    url() {
      return this.$store.state.operators.url;
    },
    affiliateLevel() {
      return this.$store.state.logged.data.is_afilliate;
    },
  },

  mounted() {
    this.userInfo = this.$store.state.logged.data;
  },
  watch: {
    "userInfo.nome_usuario": function(val) {
      this.initials(val);
    },
  },
  methods: {
    // Return firstName and Iniciais do Nome
    initials(name) {
      var names = name.split(" ");
      this.firstName = names[0];
      this.initialsName = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        this.initialsName += names[names.length - 1]
          .substring(0, 1)
          .toUpperCase();
      }
    },
    getInviteLink() {
      var linkId = this.idVinculo;
      const linkToPlayer = `${this.url}player-from-agent/agent/${linkId}`;
      return linkToPlayer;
    },

    ToRoute() {
      let affiliateLevel = this.affiliateLevel;
      if (this.retail == 0 && affiliateLevel == 1) {
        this.$router.push({
          name: "AgentFinancialCommissionsSimplified",
        });
      } else if (affiliateLevel == 1) {
        this.$router.push({ name: "AgentFinancialCommissions" });
      } else {
        this.$router.push({ name: "AgentDashboardHome" });
      }
    },
    toCampaigns() {
      this.$router.push({ name: "AgentListCampaigns" });
    },
  },

  filters: {
    saldo: function(value) {
      return value == undefined || value == null
        ? "00,00"
        : Number(value).toLocaleString("pt-BR");
    },
  },
};
</script>
